import { MetaDataMapModel } from '@em/models/restapi/MetaDataMap.Model';
import { ChangeTrackedCollectionModel } from '@shared/models/restapi/ChangeTrackedCollection.Model';

export class MetaDataMapCollectionModel extends ChangeTrackedCollectionModel<MetaDataMapModel> {
    public constructor() {
        super(MetaDataMapModel);
    }
}
